$(function () {
    const $container = $('[data-old-system-releases]');
    if (!$container.length) {
        return;
    }

    const showAllLabel = $container.data('show-all-label');
    const hideLabel = $container.data('hide-label');
    const downloadedLabel = $container.data('downloaded-label');

    $container.on('click', '.download-link', function () {
        $(this).text(downloadedLabel).attr('data-download-state', '1');
    });

    $container.on('click', '.toggle-releases-btn', function () {
        const $button = $(this);
        const $hidden = $container.find($button.data('target'));
        const expanded = $button.attr('aria-expanded') === 'true';

        $hidden.toggle(!expanded);
        $button.attr('aria-expanded', String(!expanded)).text(expanded ? showAllLabel : hideLabel);
    });
});
